<google-map #map height="500px" width="100%" [options]="options" (mapInitialized)="getMap($event)">
    <map-advanced-marker *ngIf="$captainMarker | async as captainMarker" #captainMarkerElem="mapAdvancedMarker"
        [position]="{lat: captainMarker.lat, lng: captainMarker.lon}" [content]="captainImg"
        [title]="captainMarkerTitle" class="bounce" />
        <ng-container *ngIf="$memberLocation | async as memberMarker">
            <map-advanced-marker *ngIf="(memberMarker.lat != 0 && memberMarker.lon != 0)" #memberMarkerElem="mapAdvancedMarker"
                [position]="{lat: memberMarker.lat, lng: memberMarker.lon}" [content]="memberImg" [title]="memberMarkerTitle"
                class="bounce" />
        </ng-container>
</google-map>
